export * from '@mantine/carousel'
export * from './config'